/**
 * Sidebar icons — Figma node 243-3010
 * Inline SVG components (24×24, stroke currentColor, stroke-width 2)
 * https://www.figma.com/design/bf8dF1bCgrmn6vscGI4rmb/dev?node-id=243-3010
 *
 * Replace any file under src/assets/sidebar/ with a Figma SVG export to match design exactly.
 */
import { ReactComponent as DashboardIcon } from "../../assets/sidebar/dashboard.svg";
import { ReactComponent as OrdersIcon } from "../../assets/sidebar/orders.svg";
import { ReactComponent as InventoryIcon } from "../../assets/sidebar/inventory.svg";
import { ReactComponent as StoreIcon } from "../../assets/sidebar/store.svg";
import { ReactComponent as LayersIcon } from "../../assets/sidebar/layers.svg";
import { ReactComponent as PanelsTopLeftIcon } from "../../assets/sidebar/panels-top-left.svg";
import { ReactComponent as UsersRoundIcon } from "../../assets/sidebar/users-round.svg";
import { ReactComponent as UserSquare2Icon } from "../../assets/sidebar/user-square-2.svg";
import { ReactComponent as Grid2x2PlusIcon } from "../../assets/sidebar/grid-2x2-plus.svg";
import { ReactComponent as BookOpenIcon } from "../../assets/sidebar/book-open.svg";
import { ReactComponent as FolderTreeIcon } from "../../assets/sidebar/folder-tree.svg";
import { ReactComponent as ShoppingBasketIcon } from "../../assets/sidebar/shopping-basket.svg";
import { ReactComponent as BookMarkedIcon } from "../../assets/sidebar/book-marked.svg";
import { ReactComponent as ChartNoAxesColumnIncreasingIcon } from "../../assets/sidebar/chart-no-axes-column-increasing.svg";
import { ReactComponent as FileSpreadsheetIcon } from "../../assets/sidebar/file-spreadsheet.svg";
import { ReactComponent as TruckIcon } from "../../assets/sidebar/truck.svg";
import { ReactComponent as BarChart3Icon } from "../../assets/sidebar/bar-chart-3.svg";
import { ReactComponent as SlidersHorizontalIcon } from "../../assets/sidebar/sliders-horizontal.svg";
import { ReactComponent as PrinterIcon } from "../../assets/sidebar/printer.svg";
import { ReactComponent as FileTextIcon } from "../../assets/sidebar/file-text.svg";
import { ReactComponent as HistoryIcon } from "../../assets/sidebar/history.svg";
import { ReactComponent as UserCheckIcon } from "../../assets/sidebar/user-check.svg";
import { ReactComponent as ChevronDownIcon } from "../../assets/sidebar/chevron-down.svg";

export const SIDEBAR_ICONS = {
  dashboard: DashboardIcon,
  orders: OrdersIcon,
  inventory: InventoryIcon,
  store: StoreIcon,
  layers: LayersIcon,
  panelsTopLeft: PanelsTopLeftIcon,
  usersRound: UsersRoundIcon,
  userSquare2: UserSquare2Icon,
  grid2x2Plus: Grid2x2PlusIcon,
  bookOpen: BookOpenIcon,
  folderTree: FolderTreeIcon,
  shoppingBasket: ShoppingBasketIcon,
  bookMarked: BookMarkedIcon,
  chartNoAxesColumnIncreasing: ChartNoAxesColumnIncreasingIcon,
  fileSpreadsheet: FileSpreadsheetIcon,
  truck: TruckIcon,
  barChart3: BarChart3Icon,
  slidersHorizontal: SlidersHorizontalIcon,
  printer: PrinterIcon,
  fileText: FileTextIcon,
  history: HistoryIcon,
  userCheck: UserCheckIcon,
  chevronDown: ChevronDownIcon,
};
